@if (pageReady) {
  <mat-stepper
    labelPosition="bottom"
    #stepper
    [selectedIndex]="startingIndex"
    linear="true"
    data-cy="list-ssm-stepper-progress"
  >
    @for (stepLabel of stepLabels; track $index) {
      <mat-step [label]="isMobile ? '' : stepLabel" [editable]="false" [completed]="step > $index + 1"></mat-step>
    }
    <ng-template matStepperIcon="done">
      <i role="img" aria-label="Step Completed" class="fa-solid fa-check"></i>
    </ng-template>
  </mat-stepper>
}
